import React, { useState } from 'react';
import { Box, Input, Textarea, Button, VStack, Text } from '@chakra-ui/react';
import { FaPaperPlane } from 'react-icons/fa';
import styles from '../styles/styles';

const Support = () => {
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !feedback) {
      alert('Please fill out both the email and feedback fields before submitting.');
      return;
    }

    try {
      const response = await fetch('https://zerodaythegame.com/submit-feedback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, message: feedback }),
      });

      if (response.ok) {
        alert('Thank you for your feedback!');
        setEmail('');
        setFeedback('');
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.error}`);
      }
    } catch (error) {
      alert('Failed to submit feedback. Please try again later.');
    }
  };

  return (
    <Box
      minH="100vh"
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={4}
      position="relative"
      color="white"
    >
      {/* Form */}
      <Box
        as="form"
        onSubmit={handleSubmit}
        width={['90%', '80%', '60%']}
        mt={8}
        bg="rgba(0, 0, 0, 0.6)"
        p={6}
        borderRadius="md"
      >
        <VStack spacing={4}>
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            size="md"
            borderRadius="md"
            fontSize="sm"
            color="white"
            _placeholder={{ color: 'gray.300' }}
            _focus={{ borderColor: 'orange.400', boxShadow: 'none' }}
          />
          <Textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Please submit your feedback or questions to the developers here. We usually answer within 48 hours."
            rows={4}
            required
            size="md"
            borderRadius="md"
            fontSize="sm"
            color="white"
            _placeholder={{ color: 'gray.300' }}
            _focus={{ borderColor: 'orange.400', boxShadow: 'none' }}
          />
          <Button
            type="submit"
            size="md"
            bgGradient="linear(to-r, orange.400, pink.500)"
            color="white"
            _hover={{ bgGradient: 'linear(to-r, orange.500, pink.600)', transform: 'scale(1.05)' }}
            boxShadow="xl"
            fontFamily="FjallaOne, sans-serif"
            width="75%"
            leftIcon={<FaPaperPlane />}
            textShadow="2px 2px 4px rgba(0, 0, 0, 0.7)"
          >
            Submit
          </Button>
        </VStack>
      </Box>

      {/* Q&A Section */}
      <Box width={['90%', '80%', '60%']} mt={8} textAlign="left">
        <Text fontSize="xl" mb={4} fontWeight="bold">Frequently Asked Questions</Text>

        <Text fontSize="lg" mb={2} fontWeight="bold">1. What is The Lost Diamond Journey?</Text>
        <Text mb={4}>
          It’s an app that challenges teams to visit and document 30 locations across Africa.
        </Text>

        <Text fontSize="lg" mb={2} fontWeight="bold">2. How do I track my progress?</Text>
        <Text mb={4}>
          Upload pictures and texts at each location, and they will be saved on your personal map.
        </Text>

        <Text fontSize="lg" mb={2} fontWeight="bold">3. Can I make my photos private?</Text>
        <Text mb={4}>
          Yes! You can choose to make them public for all users or private for your team.
        </Text>

        <Text fontSize="lg" mb={2} fontWeight="bold">4. What happens if I post harmful content?</Text>
        <Text mb={4}>
          Harmful content will be removed, and your account may be restricted.
        </Text>
      </Box>
    </Box>
  );
};

export default Support;
